import axios from "axios";
import { getItem, makeUrl } from "../../app/common/util/genericUtils";

export const getOrderCountReport = (params) => {
  const token = getItem("suprolUser");
  return axios({
    method: "GET",
    url: makeUrl("/orders/report/"),
    params,
    headers: {
      Authorization: `Token ${token.auth_token}`,
    },
  });
};
